import { TextField } from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import { dateTimeReportFormatter } from "../../fomatters/DateFormatter";
import InputSelect from "../InputSelect";
import Report from "../Report";
import SubGroup from "../SubGroup";
import CheckNumber from "./CheckNumber";

function removeSecondsAndMilliseconds(date) {
  // Extract the components excluding seconds and milliseconds
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day = String(date.getUTCDate()).padStart(2, "0");
  const hours = String(date.getUTCHours()).padStart(2, "0");
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");

  // Construct the formatted datetime string
  const formattedDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;

  return formattedDateTime;
}

const startDate = new Date();
startDate.setHours(0, -startDate.getTimezoneOffset(), 0);

const endDate = new Date();

const startDateValue = removeSecondsAndMilliseconds(startDate);
const endDateValue = removeSecondsAndMilliseconds(endDate);

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function CallFinder() {
  /**
   * DATES
   */
  const [startDate, setStartDate] = useState(startDateValue);
  const handleStartDateChange = useCallback(
    (event) => setStartDate(event.target.value),
    []
  );

  const [endDate, setEndDate] = useState(endDateValue);
  const handleEndDateChange = useCallback(
    (event) => setEndDate(event.target.value),
    []
  );

  /**
   * WAGER FILTERS
   */
  const [player, setPlayer] = useState("");
  const onPlayerChange = useCallback(
    (event) => setPlayer(event.target.value),
    []
  );

  const [user, setUser] = useState("");
  const onUserChange = useCallback((value) => setUser(value), []);
  const { values: users } = useDataFormatterHook({
    addEmpty: true,
    value: "loginName",
    text: "loginName",
    path: `/User/GetUsers`,
  });

  const [callId, setCallId] = useState(null);
  const onCallIdChange = useCallback((p) => setCallId(p), []);

  const [phoneLine, setPhoneLine] = useState(null);
  const onPhoneLineChange = useCallback((p) => setPhoneLine(p), []);

  return (
    <div className="flex flex-col w-full gap-4 p-4 h-max">
      <SubGroup
        title="Search"
        className="grid items-center grid-cols-3 p-2 pt-4"
      >
        <div className="flex flex-col gap-4">
          <TextField
            required
            variant="outlined"
            label="From"
            type="datetime-local"
            size="small"
            value={startDate}
            onChange={handleStartDateChange}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            required
            variant="outlined"
            label="To"
            type="datetime-local"
            size="small"
            value={endDate}
            onChange={handleEndDateChange}
            InputLabelProps={{ shrink: true }}
          />
        </div>

        <div className="flex flex-col gap-4">
          <TextField
            required
            variant="outlined"
            label="Player"
            type="text"
            size="small"
            value={player}
            onChange={onPlayerChange}
            InputLabelProps={{ shrink: true }}
          />

          <InputSelect
            variant="outlined"
            size="small"
            label="User"
            name="name"
            data={users}
            placeholder="DataFormatter"
            startValue={user}
            setSelectValue={onUserChange}
          />
        </div>
        <div className="flex flex-col gap-4">
          <CheckNumber
            name="Call ID"
            onChange={onCallIdChange}
            defaultValue={null}
          />
          <CheckNumber
            name="Phone"
            onChange={onPhoneLineChange}
            defaultValue={null}
          />
        </div>
      </SubGroup>
      <Report
        title="Call Finder"
        getUrl={() => "/User/GetCallInformation"}
        getParams={() => ({
          StartDate: startDate,
          EndDate: endDate,
          CallID: callId,
          Player: player,
          User: user,
          Phone: phoneLine,
        })}
      >
        <TableHeaderColumn dataSort dataField="IdCall" isKey>
          Call ID
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="Player">
          Player
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="StartTime"
          dataFormat={dateTimeReportFormatter}
          width="200"
        >
          Start Time
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="EndTime"
          dataFormat={dateTimeReportFormatter}
          width="200"
        >
          End Time
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="ElapsedTime">
          Elapsed Time
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="BetsTaked">
          Bets Placed
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="User">
          User
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="PhoneLine">
          Phone
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="IP">
          IP
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default CallFinder;
